import { Fragment, useEffect, useMemo } from "react";

import { WatingApproval } from "components";
import { useTranslation } from "hooks";
import {
  SIGNIN_SCREENS,
  SigninForm,
  SigninMethods,
  SignInSkelton,
  useSignin,
} from "./";

import "./signin.scss";
import { useSignUp } from "views/signup";

interface ISignIn {
  loading?: boolean; // Optional prop to indicate if loading is in progress
}

/**
 * SignIn Component
 * @param {Object} props - Component props
 * @param {boolean} [props.loading] - Optional loading state to control the display of the loading skeleton
 */
let isHandleUserVerfiedCalled = false;
export const SignIn = ({ loading }: ISignIn) => {
  // Hook to get translation functions
  const { t } = useTranslation();

  const { manageDefaultUser } = useSignUp();

  const {
    signInCurrentScreen,
    setSignInInCurrentScreen,
    currentAuthMethod,
    form,
    handleAuthMethodOptions,
    handleVerifiedUser,
    verified_user,
    handleLoginViaLink
  } = useSignin(manageDefaultUser);

  const { SIGNIN, LOADING, METHODS, APPROVAL } = SIGNIN_SCREENS;

  // Effect to manage step transition based on loading state

  useEffect(() => {
    if (verified_user && !isHandleUserVerfiedCalled) {
      isHandleUserVerfiedCalled = true;    
      handleVerifiedUser();
    } else if (!loading) {
      setSignInInCurrentScreen(SIGNIN);
    } else {
      setSignInInCurrentScreen(LOADING);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  

  /**
   * Determines which component to render based on the current step
   */
  const renderComponent = useMemo(() => {
    switch (signInCurrentScreen) {
      case LOADING:
        return <SignInSkelton />; // Render skeleton loader during the loading phase
      case METHODS:
        return (
          <SigninMethods
            handleBack={() => setSignInInCurrentScreen(SIGNIN)} // Handle going back to the sign-in step
            handleOption={handleAuthMethodOptions} // Handle option selection
          />
        );
      case APPROVAL: {
        const { countryCode = "", value } = form?.[0] ?? {};
        const val = currentAuthMethod === "phone" ? countryCode + value : value;
        return (
          <WatingApproval
            handleBack={() => setSignInInCurrentScreen(METHODS)} // Handle going back to the methods step
            handleResend={()=> handleLoginViaLink()}
            {...t(`signin.approval.${currentAuthMethod}`)} // Pass translation props to WatingApproval
            //need to replace value with val
            sublabel={t(
              `signin.approval.${currentAuthMethod}.sublabel`
            ).replace("${value}", val)}
          />
        );
      }
      default:
        return <SigninForm />; // Render sign-in form by default
    }
  }, [
    handleLoginViaLink,
    signInCurrentScreen,
    LOADING,
    METHODS,
    handleAuthMethodOptions,
    APPROVAL,
    setSignInInCurrentScreen,
    SIGNIN,
    form,
    currentAuthMethod,
    t,
  ]);

  return (
    <Fragment>
      <div className="signin-wrapper">
        <div className="signin-wrapper__inner content-center">
          {/* Render the component based on the current step */}
          {renderComponent}{" "}
        </div>
      </div>
    </Fragment>
  );
};
